/* PROCOFF - futuristic layer. Lightweight, no dependencies. */
(function () {
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('pf-design');
  var self = document.currentScript && document.currentScript.src;
  var assetBase = self ? self.replace(/procoff-future\.js(\?.*)?$/, '') : null;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var bar = document.createElement('div');
    bar.className = 'pf-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
        document.body.classList.toggle('pf-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Homepage hero film: silent, looping, desktop or mobile cut depending on screen width
    var isHome = document.querySelector('main[data-template="index"]');
    var grid = document.querySelector('#MainContent .hero__media-grid');
    var saveData = navigator.connection && navigator.connection.saveData;
    if (isHome && grid && assetBase && !reduce && !saveData) {
      var mq = window.matchMedia('(max-width: 749px)');
      var v = document.createElement('video');
      v.className = 'pf-hero-video';
      v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.setAttribute('aria-hidden', 'true'); v.preload = 'auto';
      v.addEventListener('playing', function () { v.classList.add('pf-on'); });
      grid.appendChild(v);
      var pick = function () {
        var want = assetBase + (mq.matches ? 'procoff-hero-film-mobile.mp4' : 'procoff-hero-film.mp4');
        if (v.getAttribute('data-src') === want) return;
        v.classList.remove('pf-on');
        v.setAttribute('data-src', want);
        v.src = want;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      };
      pick();
      if (mq.addEventListener) mq.addEventListener('change', pick); else if (mq.addListener) mq.addListener(pick);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }

    if (reduce) return;

    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section')).slice(1);
    if ('IntersectionObserver' in window && !document.documentElement.classList.contains('pf-design')) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pf-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      sections.forEach(function (s) { s.classList.add('pf-reveal'); io.observe(s); });
    }

    if (!finePointer) return;

    document.querySelectorAll('.hero').forEach(function (hero) {
      var glow = document.createElement('div');
      glow.className = 'pf-glow';
      hero.appendChild(glow);
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--pf-x', (ev.clientX - r.left) + 'px');
        hero.style.setProperty('--pf-y', (ev.clientY - r.top) + 'px');
      });
    });

    document.querySelectorAll('product-card, .product-card').forEach(function (card) {
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--pf-ry', (px * 6).toFixed(2) + 'deg');
        card.style.setProperty('--pf-rx', (-py * 6).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--pf-ry', '0deg');
        card.style.setProperty('--pf-rx', '0deg');
      });
    });
  });
})();
